module.exports = __webpack_public_path__ + "img/Lower Man Power Line.c4d7a076.svg";